import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const UrlIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="7px"
			viewBox="0 0 33 7"
			fill="none"
		>
			<path
				d="M2.45155 6.74121L0.675547 0.22521H2.29555L3.62755 5.37321H3.87955L4.85155 0.441211H6.77155L7.88755 5.37321H8.13955L9.32755 0.22521H10.8395L9.26755 6.74121H6.87955L5.79955 2.06121L4.83955 6.74121H2.45155ZM13.2211 6.74121L11.4451 0.22521H13.0651L14.3971 5.37321H14.6491L15.6211 0.441211H17.5411L18.6571 5.37321H18.9091L20.0971 0.22521H21.6091L20.0371 6.74121H17.6491L16.5691 2.06121L15.6091 6.74121H13.2211ZM23.9906 6.74121L22.2146 0.22521H23.8346L25.1666 5.37321H25.4186L26.3906 0.441211H28.3106L29.4266 5.37321H29.6786L30.8666 0.22521H32.3786L30.8066 6.74121H28.4186L27.3386 2.06121L26.3786 6.74121H23.9906Z"
				fill={color}
			/>
		</Icon>
	);
};
